module.exports = __webpack_public_path__ + "img/Mask_group.38e17193.png";